"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.areSameDay = areSameDay;
exports.areSameMonth = areSameMonth;
exports.clone = clone;
exports.getDefaultMaxDate = getDefaultMaxDate;
exports.getDefaultMinDate = getDefaultMinDate;
exports.isDayInRange = isDayInRange;
var _months = require("./months");
/*
 * Pinched from @blueprintjs/datetime/src/common/dateUtils
 */

function areSameDay(date1, date2) {
  return areSameMonth(date1, date2) && date1.getDate() === date2.getDate();
}
function areSameMonth(date1, date2) {
  return date1 != null && date2 != null && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear();
}
function clone(d) {
  return new Date(d.getTime());
}
function isDayInRange(date, dateRange) {
  var exclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (date === null || dateRange[0] === undefined || dateRange[1] === undefined) {
    return false;
  }
  var day = clone(date);
  var start = clone(dateRange[0]);
  var end = clone(dateRange[1]);
  day.setHours(0, 0, 0, 0);
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  return start <= day && day <= end && (!exclusive || !areSameDay(start, day) && !areSameDay(day, end));
}

/**
 * Taken from @blueprintjs/datetime/src/datePickerCore
 */
function getDefaultMaxDate() {
  var date = new Date();
  date.setFullYear(date.getFullYear() + 10);
  date.setMonth(_months.Months.DECEMBER, 31);
  return date;
}
function getDefaultMinDate() {
  var date = new Date();
  date.setFullYear(date.getFullYear() - 20);
  date.setMonth(_months.Months.JANUARY, 1);
  return date;
}